import { Component, OnInit, Input, HostListener, ElementRef, AfterViewInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { ModalService } from './modal.service';

@Component({
  selector: "pru-modal",
  templateUrl: "./modal.component.html",
  styles: [
    `
      .scrollable > .modal-dialog {
        overflow-y: initial;
      }
      .scrollable .modal-body {
        overflow-y: auto;
      }
      .no-footer .modal-footer {
        display: none;
      }
      .no-header .modal-header {
        display: none;
      }
    `
  ]
})
export class ModalComponent implements OnInit, AfterViewInit {
  isOpen = false;
  KEYCODE_TAB: number = 9;
  @Input()
  modalId: string;

  @Input()
  showClose: boolean = true;

  @Input() customModalStyle: any;

  @Input() class: string;

  @Input() size: string;

  @Input()
  modalScrollable = false;

  @Input()
  backdropClickClose: boolean = false;

  @Input()
  ariaLabelledBy: string;

  @Output()
  onShown = new EventEmitter<boolean>();

  @Output()
  onHidden = new EventEmitter<boolean>();

  @ViewChild("dismiss")
  dismissEl: ElementRef;

  containerEl: HTMLElement;

  @HostListener("document:keyup", ["$event"])
  onKeyUp(event: KeyboardEvent): void {
    if (event.keyCode === 27) {
      this.modalService.close(this.modalId);
    }
    if (
      (event.srcElement['className'] === "close" ||
        event.srcElement['id'] === "cancelButton") &&
      event.keyCode === 13
    ) {
      this.modalService.close(this.modalId);
    }
  }

  constructor(private modalService: ModalService, private el: ElementRef) {}

  ngOnInit() {
    this.modalService.registerModal(this);
  }

  ngAfterViewInit() {
    this.containerEl = this.el.nativeElement.firstChild;
  }

  open(): void {
    this.modalService.open(this.modalId);
  }

  close(): void {
    this.modalService.close(this.modalId);
  }

  fadeIn(): void {
    setTimeout(() => {
      this.containerEl.classList.add("in");
      this.preventBackgroundScrolling();
      this.onShown.emit(true);
     if (this.dismissEl) {
        this.dismissEl.nativeElement.focus();
      }
    }, 150);
  }

  fadeOut(): void {
    setTimeout(() => {
      this.containerEl.classList.remove("in");
      this.enableBackgroundScrolling();
      this.onHidden.emit(true);
    }, 150);
  }

  preventBackgroundScrolling() {
    document.body.classList.add("modal-open");
  }

  enableBackgroundScrolling() {
    document.body.classList.remove("modal-open");
  }

  @HostListener("keydown", ["$event"])
  onKeyDown(e: KeyboardEvent): any {
    if (e.key == "Tab" || e.keyCode == this.KEYCODE_TAB) {
      // Not sure why disabled elements is being mentioned separately in logic...commented out and put :enabled pseudoselector- Talha
      const /* disbaledElements = this.el.nativeElement.querySelectorAll(":disabled"), */
        modalElements = this.el.nativeElement.querySelectorAll("button:enabled:not(.hidden), input:enabled:not(.hidden), a:not(.hidden)"),
        firstElement = modalElements[0];

    let lastElement = modalElements[modalElements.length - 1 /* - disbaledElements.length */];
      if (e.shiftKey) {
        if (document.activeElement == firstElement) {
          e.preventDefault();
          setTimeout(() => {
            lastElement.focus();
          }, 0);
        }
      } else {
        if (document.activeElement == lastElement) {
          e.preventDefault();
          setTimeout(() => {
            firstElement.focus();
          }, 0);
        }
      }
    }
  }
}